import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface DuplicateReportModalProps {
  open: boolean;
  defaultTitle: string;
  onConfirm: (title: string) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
}

export const DuplicateReportModal: React.FC<DuplicateReportModalProps> = ({
  open,
  defaultTitle,
  onConfirm,
  onCancel,
  isSubmitting = false,
}) => {
  const [title, setTitle] = useState(defaultTitle);

  useEffect(() => {
    if (open) {
      setTitle(defaultTitle);
    }
  }, [open, defaultTitle]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = title.trim();
    if (trimmed) {
      onConfirm(trimmed);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Duplicar report</DialogTitle>
          <DialogDescription>
            Defina o título do novo report. O conteúdo será copiado do report original.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <label htmlFor="duplicate-report-title" className="text-sm font-medium text-gray-700">
              Título do novo report
            </label>
            <Input
              id="duplicate-report-title"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Ex: Meu report (Cópia)"
              disabled={isSubmitting}
              className="w-full"
            />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onCancel} disabled={isSubmitting}>
              Cancelar
            </Button>
            <Button type="submit" disabled={!title.trim() || isSubmitting}>
              {isSubmitting ? 'Duplicando...' : 'Duplicar'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
